<template>
  <img :src="logoUrl" :alt="altText" />
</template>

<script>
const LOGO_CONFIG = {
  opslevel: {
    full: {
      primary: "/OpsLevelLogo-Primary.svg",
      white: "/OpsLevelLogo-White.svg",
    },
    logo: {
      primary: "/OpsLevelLogoMark-Primary.svg",
      white: "/OpsLevelLogoMark-White.svg",
    },
  },
  tidra: {
    full: {
      primary: "/tidra-black-and-blue.svg",
      white: "/tidra-white.svg",
    },
    logo: {
      primary: "/tidra-icon-blue.svg",
      white: "/tidra-icon-white.svg",
    },
  },
};

export default {
  inject: ["brand"],

  props: {
    type: {
      type: String,
      default: "full",
      validator: (value) => ["full", "logo"].includes(value),
    },
    color: {
      type: String,
      default: "primary",
      validator: (value) => ["primary", "white"].includes(value),
    },
    alt: {
      type: String,
      default: "",
    },
  },

  computed: {
    logoUrl() {
      const brandConfig = LOGO_CONFIG[this.brand];
      const config = brandConfig[this.type];

      // Fall back to primary if color not available for this brand/type
      return config[this.color] || config.primary;
    },
    altText() {
      if (this.alt) {
        return this.alt;
      }

      return this.type === "logo"
        ? `${this.$t("brandName")} Logo`
        : this.$t("brandName");
    },
  },
};
</script>
